import { render, staticRenderFns } from "./PortoForm.vue?vue&type=template&id=1910b272"
import script from "./PortoForm.vue?vue&type=script&lang=js"
export * from "./PortoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports